import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { routesConfig } from '../../../shared/onboardingConfig';
import { EXISTING_ATHLETE_FLOW } from '../../../shared/onboardingConstants';
import { useOnboardingContext } from '../../../state/OnboardingContext';
import { stepToUrl } from '../../../shared/onboardingUtils';

import Welcome from '../../steps/existingAthleteFlow/Welcome';
import TermsOfService from '../../steps/existingAthleteFlow/TermsOfService';
import PrivacyPolicy from '../../steps/existingAthleteFlow/PrivacyPolicy/PrivacyPolicy';
import DirectPromotion from '../../steps/shared/DirectPromotion';
import Health from '../../steps/existingAthleteFlow/Health';
import AgeConfirmation from '../../steps/existingAthleteFlow/AgeConfirmation';
import HealthDenialOne from '../../steps/existingAthleteFlow/HealthDenialOne';
import HealthDenialTwo from '../../steps/existingAthleteFlow/HealthDenialTwo';
import AllSet from '../../steps/existingAthleteFlow/AllSet';

const ExistingAthleteFlowRoutes = () => {
  const { state } = useOnboardingContext();
  const { category } = state;

  return (
    <Switch>
      <Route
        path={stepToUrl({ category, step: EXISTING_ATHLETE_FLOW.welcome })}
        {...routesConfig}
      >
        <Welcome />
      </Route>
      <Route
        path={stepToUrl({
          category,
          step: EXISTING_ATHLETE_FLOW.termsOfService
        })}
        {...routesConfig}
      >
        <TermsOfService />
      </Route>
      <Route
        path={stepToUrl({
          category,
          step: EXISTING_ATHLETE_FLOW.privacyPolicy
        })}
        {...routesConfig}
      >
        <PrivacyPolicy />
      </Route>
      <Route
        path={stepToUrl({ category, step: EXISTING_ATHLETE_FLOW.health })}
        {...routesConfig}
      >
        <Health />
      </Route>
      <Route
        path={stepToUrl({
          category,
          step: EXISTING_ATHLETE_FLOW.privacyPolicy
        })}
        {...routesConfig}
      >
        <DirectPromotion />
      </Route>
      <Route
        path={stepToUrl({
          category,
          step: EXISTING_ATHLETE_FLOW.health_denial_one
        })}
        {...routesConfig}
      >
        <HealthDenialOne />
      </Route>
      <Route
        path={stepToUrl({
          category,
          step: EXISTING_ATHLETE_FLOW.health_denial_two
        })}
        {...routesConfig}
      >
        <HealthDenialTwo />
      </Route>
      <Route
        path={stepToUrl({
          category,
          step: EXISTING_ATHLETE_FLOW.ageConfirmation
        })}
        {...routesConfig}
      >
        <AgeConfirmation />
      </Route>
      <Route
        path={stepToUrl({
          category,
          step: EXISTING_ATHLETE_FLOW.directPromotion
        })}
        {...routesConfig}
      >
        <DirectPromotion />
      </Route>
      <Route
        path={stepToUrl({ category, step: EXISTING_ATHLETE_FLOW.all_set })}
        {...routesConfig}
      >
        <AllSet />
      </Route>
    </Switch>
  );
};

export default ExistingAthleteFlowRoutes;
